import React from "react";
import {
  AbsoluteFill,
  Audio,
  Img,
  interpolate,
  random,
  spring,
  staticFile,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

// PALET BAKU WAJIB (HARD CONSTRAINT)
const PALETTE = {
  bg: "#111815",
  card: "#18231f",
  border: "#283a33",
  white: "#f4f6f4",
  lime: "#e8f36e",
  red: "#e04336",
  waGreen: "#25D366",
  muted: "#8e9e97",
};

// 13 SEGMEN SUBJUDUL SESUAI SCENE (DILARANG KATA TABU)
const SUBTITLES = [
  { start: 0, end: 90, text: "Mau beli diamond 20 ribu aja, kenapa dibikin ribet banget?" },
  { start: 90, end: 180, text: "Ngapain juga harus minta no WhatsApp sama email segala?" },
  { start: 180, end: 330, text: "Niatnya cuman mau top up santai, malah disuruh mikir panjang!" },
  { start: 330, end: 480, text: "Pakai suruh masukin no WA pribadi, ujungnya data kesebar." },
  { start: 480, end: 630, text: "Tiap subuh dibombardir spam chat gak jelas, beneran bikin pusing!" },
  { start: 630, end: 780, text: "Inbox email penuh sampah promo alay dan link gak jelas." },
  { start: 780, end: 960, text: "Temen mabar udah pada ready, order gak jadi-jadi malah pending terus!" },
  { start: 960, end: 1100, text: "Udah cukup dramanya. Sekarang saatnya pindah ke yang satset." },
  { start: 1100, end: 1260, text: "Gak perlu no WA, gak butuh email, nol urusan berbelit." },
  { start: 1260, end: 1440, text: "Cukup masukin no ID akun game kamu doang, beres!" },
  { start: 1440, end: 1620, text: "Nickname langsung nongol otomatis, seratus persen cocok tanpa salah." },
  { start: 1620, end: 1800, text: "Tinggal scan QRIS, satu koma dua detik langsung meluncur masuk." },
  { start: 1800, end: 2028, text: "KyuStore dot com, top up satset tanpa ribet buat para gamer!" },
];

export const KyuStoreRombakGaul: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Helper spring
  const getSceneSpring = (startFrame: number, damping = 14, stiffness = 150) =>
    spring({
      frame: Math.max(0, frame - startFrame),
      fps,
      config: { damping, stiffness },
    });

  // Active Subtitle
  const currentSub = SUBTITLES.find((s) => frame >= s.start && frame < s.end);
  const currentSubText = currentSub ? currentSub.text : "";

  // Deterministic micro shake for urgency
  const shake1 = (random(`shk-a-${Math.floor(frame / 4)}`) - 0.5) * 6;
  const shake2 = (random(`shk-b-${Math.floor(frame / 4)}`) - 0.5) * 6;

  // Background switches to full lime for Scene 8 [960-1100]
  const isScene8 = frame >= 960 && frame < 1100;
  const currentBg = isScene8 ? PALETTE.lime : PALETTE.bg;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: currentBg,
        color: PALETTE.white,
        fontFamily: "'Rajdhani', sans-serif",
        overflow: "hidden",
      }}
    >
      {/* Audio VO & Sound */}
      <Audio src={staticFile("audio/satire_mastered.mp3")} volume={1} />

      {/* ============================================================== */}
      {/* SCENE 1 [0-90]: Full-bleed big type "MAU BELI DIAMOND 20RB..." */}
      {/* ============================================================== */}
      {frame >= 0 && frame < 90 && (() => {
        const spr = getSceneSpring(0, 13, 140);
        const clipProgress = interpolate(spr, [0, 1], [100, 0], {
          extrapolateLeft: "clamp",
          extrapolateRight: "clamp",
        });

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "90px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              clipPath: `inset(0 0 ${clipProgress}% 0)`,
            }}
          >
            {/* Tag Corner */}
            <div
              style={{
                alignSelf: "flex-start",
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.border}`,
                padding: "10px 22px",
                borderRadius: 6,
                transform: "rotate(-2deg)",
                marginBottom: 60,
              }}
            >
              <span
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 32,
                  color: PALETTE.lime,
                  letterSpacing: "2px",
                  fontWeight: 700,
                }}
              >
                NGGAK PERLU REPOT 01/13
              </span>
            </div>

            {/* Big Typography Stack */}
            <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 110,
                  lineHeight: 0.95,
                  color: PALETTE.white,
                  letterSpacing: "-1px",
                }}
              >
                MAU BELI
              </div>
              <div
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 240,
                  lineHeight: 0.82,
                  color: PALETTE.lime,
                  letterSpacing: "4px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                }}
              >
                DIAMOND
              </div>
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 160,
                  lineHeight: 0.95,
                  color: PALETTE.white,
                  letterSpacing: "-2px",
                  marginTop: 10,
                }}
              >
                20RB...
              </div>
            </div>

            {/* Asymmetric Brutal Ribbon */}
            <div
              style={{
                marginTop: 80,
                alignSelf: "flex-start",
                backgroundColor: PALETTE.red,
                color: PALETTE.white,
                padding: "16px 32px",
                borderRadius: 4,
                transform: "rotate(-3deg)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 48,
                  fontWeight: 700,
                  letterSpacing: "1px",
                }}
              >
                RECEH DOANG, TAPI KENAPA RIBET BANGET?!
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 2 [90-180]: Blok merah & Strike Items                    */}
      {/* ============================================================== */}
      {frame >= 90 && frame < 180 && (() => {
        const s2Spr = getSceneSpring(90, 12, 160);
        const item1Spr = getSceneSpring(115, 14, 170);
        const item2Spr = getSceneSpring(135, 14, 170);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "120px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 40,
            }}
          >
            {/* Blok Merah Header */}
            <div
              style={{
                backgroundColor: PALETTE.red,
                padding: "36px 40px",
                borderRadius: 8,
                transform: `scale(${interpolate(s2Spr, [0, 1], [0.92, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })})`,
              }}
            >
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 68,
                  lineHeight: 1.05,
                  color: PALETTE.white,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                }}
              >
                NGAPA HARUS MINTA NO. WA & EMAIL?!
              </div>
            </div>

            {/* Strike Item 1 */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.red}`,
                borderRadius: 8,
                padding: "30px 40px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                transform: `translateX(${interpolate(item1Spr, [0, 1], [-120, 0], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}px)`,
                opacity: interpolate(item1Spr, [0, 0.4, 1], [0, 1, 1]),
                position: "relative",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                <span
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 64,
                    color: PALETTE.white,
                    textDecoration: item1Spr > 0.6 ? "line-through" : "none",
                    textDecorationColor: PALETTE.red,
                    textDecorationThickness: "6px",
                  }}
                >
                  1. NO WHATSAPP
                </span>
                <span style={{ fontSize: 44, color: PALETTE.red, fontWeight: 900 }}>✕</span>
              </div>
              <div
                style={{
                  backgroundColor: PALETTE.red,
                  color: PALETTE.white,
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 38,
                  padding: "8px 24px",
                  borderRadius: 4,
                  fontWeight: 700,
                  transform: "rotate(3deg)",
                }}
              >
                GAK PERLU
              </div>
            </div>

            {/* Strike Item 2 */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.red}`,
                borderRadius: 8,
                padding: "30px 40px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                transform: `translateX(${interpolate(item2Spr, [0, 1], [120, 0], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}px)`,
                opacity: interpolate(item2Spr, [0, 0.4, 1], [0, 1, 1]),
                position: "relative",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                <span
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 64,
                    color: PALETTE.white,
                    textDecoration: item2Spr > 0.6 ? "line-through" : "none",
                    textDecorationColor: PALETTE.red,
                    textDecorationThickness: "6px",
                  }}
                >
                  2. EMAIL
                </span>
                <span style={{ fontSize: 44, color: PALETTE.red, fontWeight: 900 }}>✕</span>
              </div>
              <div
                style={{
                  backgroundColor: PALETTE.red,
                  color: PALETTE.white,
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 38,
                  padding: "8px 24px",
                  borderRadius: 4,
                  fontWeight: 700,
                  transform: "rotate(-3deg)",
                }}
              >
                GAK PERLU
              </div>
            </div>

            {/* Tag ngeselin */}
            <div
              style={{
                alignSelf: "center",
                marginTop: 20,
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.border}`,
                padding: "16px 36px",
                borderRadius: 6,
                transform: "rotate(-1deg)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 42,
                  color: PALETTE.lime,
                  letterSpacing: "1px",
                }}
              >
                REWEL BANGET! MAU JUALAN APA NGERJAIN ORANG?
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 3 [180-330]: Split 50/50 "NIATNYA CUMAN TOP UP" VS REALITA */}
      {/* ============================================================== */}
      {frame >= 180 && frame < 330 && (() => {
        const s3Left = getSceneSpring(180, 14, 150);
        const s3Right = getSceneSpring(200, 12, 140);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
            }}
          >
            {/* Sisi Kiri: 50% */}
            <div
              style={{
                width: 540,
                height: 1920,
                backgroundColor: PALETTE.bg,
                borderRight: `3px solid ${PALETTE.border}`,
                padding: "140px 50px",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                transform: `translateX(${interpolate(s3Left, [0, 1], [-80, 0], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}px)`,
              }}
            >
              <div
                style={{
                  backgroundColor: PALETTE.card,
                  border: `2px solid ${PALETTE.lime}`,
                  alignSelf: "flex-start",
                  padding: "8px 20px",
                  borderRadius: 4,
                  marginBottom: 40,
                }}
              >
                <span
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 28,
                    color: PALETTE.lime,
                    fontWeight: 700,
                  }}
                >
                  RENCANA AWAL
                </span>
              </div>

              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 72,
                  lineHeight: 1,
                  color: PALETTE.white,
                  textTransform: "uppercase",
                  marginBottom: 30,
                }}
              >
                NIATNYA CUMAN TOP UP
              </div>

              <div
                style={{
                  fontFamily: "'Rajdhani', sans-serif",
                  fontSize: 28,
                  lineHeight: 1.3,
                  color: PALETTE.muted,
                  fontWeight: 600,
                }}
              >
                Pengen beli diamond receh, langsung main push rank bareng tongkrongan.
              </div>

              {/* Graphic Box */}
              <div
                style={{
                  marginTop: 60,
                  backgroundColor: PALETTE.card,
                  border: `2px solid ${PALETTE.border}`,
                  padding: "40px 20px",
                  borderRadius: 12,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 100,
                    color: PALETTE.lime,
                    lineHeight: 0.9,
                  }}
                >
                  20.000
                </div>
                <div style={{ color: PALETTE.white, fontSize: 24, fontWeight: 700 }}>
                  RUPIAH DOANG
                </div>
              </div>
            </div>

            {/* Sisi Kanan: 50% */}
            <div
              style={{
                width: 540,
                height: 1920,
                backgroundColor: PALETTE.card,
                padding: "140px 50px",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                transform: `translateX(${interpolate(s3Right, [0, 1], [80, 0], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}px)`,
              }}
            >
              <div
                style={{
                  backgroundColor: PALETTE.red,
                  alignSelf: "flex-start",
                  padding: "8px 20px",
                  borderRadius: 4,
                  marginBottom: 40,
                }}
              >
                <span
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 28,
                    color: PALETTE.white,
                    fontWeight: 700,
                  }}
                >
                  KENYATAANNYA
                </span>
              </div>

              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 64,
                  lineHeight: 1,
                  color: PALETTE.white,
                  textTransform: "uppercase",
                  marginBottom: 20,
                }}
              >
                DISURUH PIKIRAN PANJANG
              </div>

              {/* Giant Number */}
              <div style={{ marginTop: 20, textAlign: "center" }}>
                <div
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 260,
                    lineHeight: 0.75,
                    color: PALETTE.red,
                    fontWeight: 700,
                  }}
                >
                  15+
                </div>
                <div
                  style={{
                    fontFamily: "'Anton', sans-serif",
                    fontSize: 36,
                    color: PALETTE.white,
                    marginTop: 10,
                  }}
                >
                  LANGKAH RIBET
                </div>
                <div
                  style={{
                    fontFamily: "'Rajdhani', sans-serif",
                    fontSize: 24,
                    color: PALETTE.muted,
                    marginTop: 8,
                    fontWeight: 600,
                  }}
                >
                  Minta data ini itu yang gak jelas gunanya!
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 4 [330-480]: Field Merah "INPUT NO. WA" + [BOCOR] SPAM  */}
      {/* ============================================================== */}
      {frame >= 330 && frame < 480 && (() => {
        const s4Spr = getSceneSpring(330, 13, 150);
        const alertSpr = getSceneSpring(365, 12, 170);
        const cursorBlink = Math.floor(frame / 12) % 2 === 0;

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "140px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 36,
            }}
          >
            {/* Tag Scene */}
            <div
              style={{
                alignSelf: "flex-start",
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.red}`,
                padding: "8px 24px",
                borderRadius: 4,
              }}
            >
              <span style={{ fontFamily: "'Teko', sans-serif", fontSize: 28, color: PALETTE.red }}>
                JEBAKAN NO. 04
              </span>
            </div>

            {/* Input Form Mockup */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.red}`,
                borderRadius: 12,
                padding: 40,
                transform: `scale(${interpolate(s4Spr, [0, 1], [0.94, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })})`,
              }}
            >
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 48,
                  color: PALETTE.red,
                  marginBottom: 24,
                  textTransform: "uppercase",
                }}
              >
                INPUT NO. WA (KATANYA WAJIB)
              </div>

              {/* Fake Field Box */}
              <div
                style={{
                  backgroundColor: PALETTE.bg,
                  border: `2px solid ${PALETTE.border}`,
                  padding: "24px 30px",
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 56,
                    color: PALETTE.white,
                    letterSpacing: "3px",
                  }}
                >
                  0812-9842-XXXX
                  {cursorBlink && <span style={{ color: PALETTE.red }}>|</span>}
                </span>
                <span
                  style={{
                    backgroundColor: PALETTE.red,
                    color: PALETTE.white,
                    padding: "4px 14px",
                    borderRadius: 4,
                    fontSize: 20,
                    fontWeight: 700,
                  }}
                >
                  WAJIB
                </span>
              </div>
            </div>

            {/* Alert Banner Bocor */}
            <div
              style={{
                backgroundColor: PALETTE.red,
                color: PALETTE.white,
                padding: "28px 36px",
                borderRadius: 8,
                transform: `scale(${interpolate(alertSpr, [0, 1], [0.85, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}) rotate(-2deg)`,
                opacity: interpolate(alertSpr, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 15px 40px rgba(224, 67, 54, 0.4)",
              }}
            >
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 54,
                  lineHeight: 1,
                  textAlign: "center",
                  letterSpacing: "1px",
                }}
              >
                [BOCOR] RISIKO DISPAM 100%
              </div>
            </div>

            {/* Risk Gauge Simulation */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.border}`,
                borderRadius: 8,
                padding: "28px 32px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 16,
                  fontFamily: "'Rajdhani', sans-serif",
                  fontSize: 24,
                  fontWeight: 700,
                }}
              >
                <span>PELUANG NOMOR PRIBADI KESEBAR:</span>
                <span style={{ color: PALETTE.red }}>MAKSIMAL (100%)</span>
              </div>
              <div
                style={{
                  height: 20,
                  backgroundColor: PALETTE.bg,
                  borderRadius: 10,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${interpolate(s4Spr, [0, 1], [0, 100], {
                      extrapolateLeft: "clamp",
                      extrapolateRight: "clamp",
                    })}%`,
                    height: "100%",
                    backgroundColor: PALETTE.red,
                  }}
                />
              </div>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 5 [480-630]: Simulasi Chat WA Subuh 03:41 AM             */}
      {/* ============================================================== */}
      {frame >= 480 && frame < 630 && (() => {
        const b1Spr = getSceneSpring(495, 14, 160);
        const b2Spr = getSceneSpring(525, 14, 160);
        const stampSpr = getSceneSpring(565, 12, 170);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "100px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {/* Phone Screen Mockup */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.border}`,
                borderRadius: 16,
                padding: "0 0 40px 0",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {/* WA Header */}
              <div
                style={{
                  backgroundColor: "#1f2c26",
                  borderBottom: `2px solid ${PALETTE.border}`,
                  padding: "22px 30px",
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                }}
              >
                <div
                  style={{
                    width: 54,
                    height: 54,
                    borderRadius: "50%",
                    backgroundColor: PALETTE.waGreen,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "'Anton', sans-serif",
                    fontSize: 28,
                    color: PALETTE.bg,
                  }}
                >
                  SP
                </div>
                <div>
                  <div style={{ fontSize: 28, fontWeight: 700, color: PALETTE.white }}>
                    Toko Gak Jelas Promo
                  </div>
                  <div style={{ fontSize: 20, color: PALETTE.waGreen, fontWeight: 600 }}>
                    Online jam 03:41 AM
                  </div>
                </div>
              </div>

              {/* Chat Canvas */}
              <div
                style={{
                  padding: "40px 30px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 26,
                  backgroundColor: PALETTE.bg,
                }}
              >
                {/* Bubble 1 */}
                <div
                  style={{
                    alignSelf: "flex-start",
                    backgroundColor: PALETTE.card,
                    border: `2px solid ${PALETTE.waGreen}`,
                    borderRadius: "16px 16px 16px 2px",
                    padding: "20px 26px",
                    maxWidth: "85%",
                    transform: `translateY(${interpolate(b1Spr, [0, 1], [30, 0], {
                      extrapolateLeft: "clamp",
                      extrapolateRight: "clamp",
                    })}px)`,
                    opacity: interpolate(b1Spr, [0, 0.5, 1], [0, 1, 1]),
                  }}
                >
                  <div style={{ fontSize: 28, lineHeight: 1.3, color: PALETTE.white }}>
                    P... Kak promo subuh nih kak order yuk... mumpung diskon diamond!
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      color: PALETTE.waGreen,
                      textAlign: "right",
                      marginTop: 8,
                      fontWeight: 700,
                    }}
                  >
                    03:41 AM ✓✓
                  </div>
                </div>

                {/* Bubble 2 */}
                <div
                  style={{
                    alignSelf: "flex-start",
                    backgroundColor: PALETTE.card,
                    border: `2px solid ${PALETTE.waGreen}`,
                    borderRadius: "16px 16px 16px 2px",
                    padding: "20px 26px",
                    maxWidth: "85%",
                    transform: `translateY(${interpolate(b2Spr, [0, 1], [30, 0], {
                      extrapolateLeft: "clamp",
                      extrapolateRight: "clamp",
                    })}px)`,
                    opacity: interpolate(b2Spr, [0, 0.5, 1], [0, 1, 1]),
                  }}
                >
                  <div style={{ fontSize: 28, lineHeight: 1.3, color: PALETTE.white }}>
                    P... Masih melek kan kak? Buruan checkout kupon kamu sebelum hangus!
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      color: PALETTE.waGreen,
                      textAlign: "right",
                      marginTop: 8,
                      fontWeight: 700,
                    }}
                  >
                    03:42 AM ✓✓
                  </div>
                </div>
              </div>
            </div>

            {/* Giant Stamp: CAPEK DIBOMBARDIR */}
            <div
              style={{
                marginTop: 40,
                alignSelf: "center",
                backgroundColor: PALETTE.red,
                color: PALETTE.white,
                padding: "20px 48px",
                borderRadius: 8,
                transform: `scale(${interpolate(stampSpr, [0, 1], [0.8, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}) rotate(-4deg)`,
                opacity: interpolate(stampSpr, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 60,
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                }}
              >
                CAPEK DIBOMBARDIR SPAM!
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 6 [630-780]: Inbox Email Sampah 99+ Notif               */}
      {/* ============================================================== */}
      {frame >= 630 && frame < 780 && (() => {
        const s6Spr = getSceneSpring(630, 14, 150);
        const item1 = getSceneSpring(650, 14, 160);
        const item2 = getSceneSpring(680, 14, 160);
        const stamp6 = getSceneSpring(710, 12, 170);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "120px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 26,
            }}
          >
            {/* Header Inbox */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.border}`,
                borderRadius: 8,
                padding: "24px 30px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                transform: `scale(${interpolate(s6Spr, [0, 1], [0.94, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })})`,
              }}
            >
              <span style={{ fontFamily: "'Anton', sans-serif", fontSize: 44, color: PALETTE.white }}>
                KOTAK MASUK SAMPAH
              </span>
              <span
                style={{
                  backgroundColor: PALETTE.red,
                  color: PALETTE.white,
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 34,
                  padding: "4px 18px",
                  borderRadius: 4,
                  fontWeight: 700,
                }}
              >
                99+ NOTIF GAK PENTING
              </span>
            </div>

            {/* Email Item 1 */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                borderLeft: `8px solid ${PALETTE.red}`,
                borderTop: `1px solid ${PALETTE.border}`,
                borderRight: `1px solid ${PALETTE.border}`,
                borderBottom: `1px solid ${PALETTE.border}`,
                borderRadius: "0 8px 8px 0",
                padding: "24px 30px",
                transform: `translateX(${interpolate(item1, [0, 1], [-80, 0], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}px)`,
                opacity: interpolate(item1, [0, 0.4, 1], [0, 1, 1]),
              }}
            >
              <div style={{ fontSize: 22, color: PALETTE.lime, fontWeight: 700, marginBottom: 8 }}>
                PromoSpamTopUp_99
              </div>
              <div style={{ fontSize: 28, fontWeight: 700, color: PALETTE.white, marginBottom: 6 }}>
                [PROMO] Flash Sale top up diamond jangan lewatkan!
              </div>
              <div style={{ fontSize: 22, color: PALETTE.muted }}>
                Halo kak, kami kirimkan 50 email hari ini biar kakak gak lupa...
              </div>
            </div>

            {/* Email Item 2 */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                borderLeft: `8px solid ${PALETTE.red}`,
                borderTop: `1px solid ${PALETTE.border}`,
                borderRight: `1px solid ${PALETTE.border}`,
                borderBottom: `1px solid ${PALETTE.border}`,
                borderRadius: "0 8px 8px 0",
                padding: "24px 30px",
                transform: `translateX(${interpolate(item2, [0, 1], [-80, 0], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}px)`,
                opacity: interpolate(item2, [0, 0.4, 1], [0, 1, 1]),
              }}
            >
              <div style={{ fontSize: 22, color: PALETTE.red, fontWeight: 700, marginBottom: 8 }}>
                PeringatanAkunGakJelas
              </div>
              <div style={{ fontSize: 28, fontWeight: 700, color: PALETTE.white, marginBottom: 6 }}>
                [ALERT] Klik link konfirmasi email kamu sekarang ribet...
              </div>
              <div style={{ fontSize: 22, color: PALETTE.muted }}>
                Mohon klik tautan berbelit ini atau pesanan kamu dibatalkan sepihak...
              </div>
            </div>

            {/* Stamp Ribbon */}
            <div
              style={{
                marginTop: 30,
                alignSelf: "center",
                backgroundColor: PALETTE.red,
                color: PALETTE.white,
                padding: "18px 40px",
                borderRadius: 6,
                transform: `scale(${interpolate(stamp6, [0, 1], [0.85, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}) rotate(3deg)`,
                opacity: interpolate(stamp6, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 50,
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
              >
                PENUH SAMPAH GAK JELAS!
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 7 [780-960]: Panik "TEMEN UDAH READY!!" "PENDING #47"     */}
      {/* ============================================================== */}
      {frame >= 780 && frame < 960 && (() => {
        const s7Spr = getSceneSpring(780, 10, 180);
        const stamp7 = getSceneSpring(820, 12, 190);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "120px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 36,
              transform: `scale(${interpolate(s7Spr, [0, 1], [0.94, 1], {
                extrapolate: "clamp",
              })}) translate(${shake1}px, ${shake2}px)`,
            }}
          >
            {/* Header Panik */}
            <div
              style={{
                fontFamily: "'Teko', sans-serif",
                fontSize: 140,
                lineHeight: 0.85,
                color: PALETTE.lime,
                fontWeight: 700,
                textAlign: "center",
                letterSpacing: "2px",
              }}
            >
              TEMEN UDAH READY!!
            </div>

            {/* Match Countdown Box */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.red}`,
                borderRadius: 12,
                padding: "36px 40px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontFamily: "'Rajdhani', sans-serif",
                  fontSize: 26,
                  color: PALETTE.red,
                  fontWeight: 700,
                  marginBottom: 10,
                }}
              >
                COUNTDOWN LOBBY GAME
              </div>
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 92,
                  color: PALETTE.white,
                  letterSpacing: "2px",
                }}
              >
                MATCH MULAI 00:15
              </div>
            </div>

            {/* Stamp PENDING #47 */}
            <div
              style={{
                alignSelf: "center",
                backgroundColor: PALETTE.red,
                color: PALETTE.white,
                padding: "24px 50px",
                borderRadius: 8,
                transform: `scale(${interpolate(stamp7, [0, 1], [0.75, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}) rotate(-6deg)`,
                opacity: interpolate(stamp7, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 25px 60px rgba(224, 67, 54, 0.5)",
                border: `4px solid ${PALETTE.white}`,
              }}
            >
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 76,
                  lineHeight: 1,
                  letterSpacing: "2px",
                  textAlign: "center",
                }}
              >
                PENDING #47
              </div>
            </div>

            {/* Urgency text */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.border}`,
                padding: "20px 30px",
                borderRadius: 6,
                textAlign: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 48,
                  color: PALETTE.lime,
                  fontWeight: 700,
                }}
              >
                ORDER GAK JADI-JADI! KEBURU DITINGGAL MABAR!
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 8 [960-1100]: Hard Reset Full-Bleed Lime "CUKUP. PINDAH" */}
      {/* ============================================================== */}
      {frame >= 960 && frame < 1100 && (() => {
        const s8Spr = getSceneSpring(960, 12, 160);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "160px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              transform: `scale(${interpolate(s8Spr, [0, 1], [0.95, 1], {
                extrapolateLeft: "clamp",
                extrapolateRight: "clamp",
              })})`,
            }}
          >
            <div
              style={{
                fontFamily: "'Anton', sans-serif",
                fontSize: 220,
                lineHeight: 0.85,
                color: PALETTE.bg,
                letterSpacing: "-2px",
                textTransform: "uppercase",
              }}
            >
              CUKUP.
            </div>

            <div
              style={{
                fontFamily: "'Teko', sans-serif",
                fontSize: 200,
                lineHeight: 0.82,
                color: PALETTE.bg,
                letterSpacing: "3px",
                fontWeight: 700,
                textTransform: "uppercase",
              }}
            >
              PINDAH SAJA.
            </div>

            {/* Inverted Black Box */}
            <div
              style={{
                marginTop: 60,
                backgroundColor: PALETTE.bg,
                color: PALETTE.lime,
                padding: "20px 40px",
                borderRadius: 6,
                transform: "rotate(-2deg)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 52,
                  fontWeight: 700,
                  letterSpacing: "1px",
                }}
              >
                SAATNYA TOP UP WARAS TANPA DRAMA!
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 9 [1100-1260]: Manifesto 2 Kolom "NO WA / NO EMAIL"      */}
      {/* ============================================================== */}
      {frame >= 1100 && frame < 1260 && (() => {
        const col1Spr = getSceneSpring(1100, 14, 150);
        const col2Spr = getSceneSpring(1125, 14, 150);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "120px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 36,
            }}
          >
            {/* Header Manifesto */}
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontFamily: "'Rajdhani', sans-serif",
                  fontSize: 26,
                  color: PALETTE.lime,
                  fontWeight: 700,
                  letterSpacing: "3px",
                  marginBottom: 10,
                }}
              >
                STANDAR BARU TOP UP
              </div>
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 70,
                  color: PALETTE.white,
                  letterSpacing: "1px",
                }}
              >
                BEBAS DARI KEBODOHAN
              </div>
            </div>

            {/* Two Column Grid */}
            <div style={{ display: "flex", gap: 30, marginTop: 20 }}>
              {/* Kolom 1 */}
              <div
                style={{
                  flex: 1,
                  backgroundColor: PALETTE.card,
                  border: `3px solid ${PALETTE.lime}`,
                  borderRadius: 12,
                  padding: "40px 30px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  transform: `translateY(${interpolate(col1Spr, [0, 1], [60, 0], {
                    extrapolateLeft: "clamp",
                    extrapolateRight: "clamp",
                  })}px)`,
                  opacity: interpolate(col1Spr, [0, 0.4, 1], [0, 1, 1]),
                }}
              >
                <div
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 48,
                    color: PALETTE.red,
                    fontWeight: 700,
                    marginBottom: 16,
                  }}
                >
                  NO WHATSAPP?
                </div>
                <div
                  style={{
                    fontFamily: "'Anton', sans-serif",
                    fontSize: 64,
                    color: PALETTE.lime,
                    marginBottom: 20,
                  }}
                >
                  GAK PERLU!
                </div>
                <div
                  style={{
                    fontFamily: "'Rajdhani', sans-serif",
                    fontSize: 24,
                    color: PALETTE.muted,
                    lineHeight: 1.3,
                  }}
                >
                  Nomor pribadi kamu aman di kantong sendiri, nol teror spam.
                </div>
              </div>

              {/* Kolom 2 */}
              <div
                style={{
                  flex: 1,
                  backgroundColor: PALETTE.card,
                  border: `3px solid ${PALETTE.lime}`,
                  borderRadius: 12,
                  padding: "40px 30px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  transform: `translateY(${interpolate(col2Spr, [0, 1], [60, 0], {
                    extrapolateLeft: "clamp",
                    extrapolateRight: "clamp",
                  })}px)`,
                  opacity: interpolate(col2Spr, [0, 0.4, 1], [0, 1, 1]),
                }}
              >
                <div
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 48,
                    color: PALETTE.red,
                    fontWeight: 700,
                    marginBottom: 16,
                  }}
                >
                  NO EMAIL?
                </div>
                <div
                  style={{
                    fontFamily: "'Anton', sans-serif",
                    fontSize: 64,
                    color: PALETTE.lime,
                    marginBottom: 20,
                  }}
                >
                  GAK PERLU!
                </div>
                <div
                  style={{
                    fontFamily: "'Rajdhani', sans-serif",
                    fontSize: 24,
                    color: PALETTE.muted,
                    lineHeight: 1.3,
                  }}
                >
                  Inbox bersih, gak ada drama klik link konfirmasi ribet.
                </div>
              </div>
            </div>

            {/* Bottom Motto */}
            <div
              style={{
                marginTop: 20,
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.border}`,
                padding: "20px 30px",
                borderRadius: 8,
                textAlign: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 44,
                  color: PALETTE.white,
                  letterSpacing: "1px",
                }}
              >
                TOP UP YA TINGGAL TOP UP, GAK USAH REGEJEK!
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 10 [1260-1440]: Input Cuma ID Game + Badge "CUKUP INI"   */}
      {/* ============================================================== */}
      {frame >= 1260 && frame < 1440 && (() => {
        const s10Spr = getSceneSpring(1260, 13, 150);
        const badgeSpr = getSceneSpring(1300, 12, 170);

        // Typewriter effect for ID
        const targetText = "84920194 (2026)";
        const typedCount = Math.min(
          targetText.length,
          Math.floor((frame - 1270) * 0.8)
        );
        const visibleId = typedCount > 0 ? targetText.slice(0, typedCount) : "";

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "140px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 36,
            }}
          >
            {/* Step Label */}
            <div
              style={{
                alignSelf: "flex-start",
                backgroundColor: PALETTE.lime,
                color: PALETTE.bg,
                padding: "8px 24px",
                borderRadius: 4,
                fontFamily: "'Teko', sans-serif",
                fontSize: 30,
                fontWeight: 700,
              }}
            >
              SATU-SATUNYA LANGKAH
            </div>

            {/* Title */}
            <div
              style={{
                fontFamily: "'Anton', sans-serif",
                fontSize: 78,
                color: PALETTE.white,
                lineHeight: 1,
              }}
            >
              MASUKIN ID GAME
            </div>

            {/* ID Input Mockup */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.lime}`,
                borderRadius: 12,
                padding: "36px 40px",
                transform: `scale(${interpolate(s10Spr, [0, 1], [0.94, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })})`,
              }}
            >
              <div
                style={{
                  fontFamily: "'Rajdhani', sans-serif",
                  fontSize: 22,
                  color: PALETTE.lime,
                  fontWeight: 700,
                  marginBottom: 16,
                  letterSpacing: "2px",
                }}
              >
                USER ID & ZONE ID
              </div>
              <div
                style={{
                  backgroundColor: PALETTE.bg,
                  border: `2px solid ${PALETTE.border}`,
                  padding: "24px 30px",
                  borderRadius: 8,
                }}
              >
                <span
                  style={{
                    fontFamily: "'Teko', sans-serif",
                    fontSize: 68,
                    color: PALETTE.white,
                    letterSpacing: "4px",
                  }}
                >
                  {visibleId}
                  <span style={{ color: PALETTE.lime }}>|</span>
                </span>
              </div>
            </div>

            {/* Badge Cukup Ini Aja */}
            <div
              style={{
                alignSelf: "center",
                backgroundColor: PALETTE.lime,
                color: PALETTE.bg,
                padding: "20px 46px",
                borderRadius: 6,
                transform: `scale(${interpolate(badgeSpr, [0, 1], [0.75, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}) rotate(-2deg)`,
                opacity: interpolate(badgeSpr, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 15px 40px rgba(232, 243, 110, 0.3)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 60,
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
              >
                CUKUP INI AJA ✓
              </span>
            </div>

            <div
              style={{
                textAlign: "center",
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 26,
                color: PALETTE.muted,
                fontWeight: 600,
              }}
            >
              Nol nomor hp · Nol email · Nol drama pusing
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 11 [1440-1620]: Auto-detect "Zura_Official_ML" 100% Cocok */}
      {/* ============================================================== */}
      {frame >= 1440 && frame < 1620 && (() => {
        const s11Spr = getSceneSpring(1440, 13, 160);
        const matchSpr = getSceneSpring(1475, 12, 180);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "140px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 36,
            }}
          >
            {/* Title */}
            <div>
              <div
                style={{
                  fontFamily: "'Rajdhani', sans-serif",
                  fontSize: 26,
                  color: PALETTE.lime,
                  fontWeight: 700,
                  letterSpacing: "3px",
                  marginBottom: 10,
                }}
              >
                DETEKSI OTOMATIS
              </div>
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 78,
                  color: PALETTE.white,
                  lineHeight: 1,
                }}
              >
                NICKNAME LANGSUNG MUNCUL
              </div>
            </div>

            {/* Profile Nick Card */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.lime}`,
                borderRadius: 12,
                padding: "36px 40px",
                display: "flex",
                alignItems: "center",
                gap: 30,
                transform: `translateX(${interpolate(s11Spr, [0, 1], [-80, 0], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}px)`,
                opacity: interpolate(s11Spr, [0, 0.4, 1], [0, 1, 1]),
              }}
            >
              {/* Avatar Box */}
              <div
                style={{
                  width: 90,
                  height: 90,
                  backgroundColor: PALETTE.bg,
                  border: `3px solid ${PALETTE.lime}`,
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 48,
                  color: PALETTE.lime,
                }}
              >
                Z
              </div>

              <div>
                <div
                  style={{
                    fontFamily: "'Anton', sans-serif",
                    fontSize: 56,
                    color: PALETTE.white,
                    letterSpacing: "1px",
                  }}
                >
                  Zura_Official_ML
                </div>
                <div
                  style={{
                    fontFamily: "'Rajdhani', sans-serif",
                    fontSize: 24,
                    color: PALETTE.muted,
                    fontWeight: 600,
                    marginTop: 4,
                  }}
                >
                  Server ID: 2026 (Indonesia)
                </div>
              </div>
            </div>

            {/* Badge Cocok */}
            <div
              style={{
                alignSelf: "center",
                backgroundColor: PALETTE.lime,
                color: PALETTE.bg,
                padding: "20px 48px",
                borderRadius: 8,
                transform: `scale(${interpolate(matchSpr, [0, 1], [0.8, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}) rotate(2deg)`,
                opacity: interpolate(matchSpr, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 15px 40px rgba(232, 243, 110, 0.3)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 60,
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
              >
                KETEMU! 100% COCOK ✓
              </span>
            </div>

            {/* Speed Info Box */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `2px solid ${PALETTE.border}`,
                borderRadius: 8,
                padding: "20px 30px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: 24, fontWeight: 700, color: PALETTE.white }}>
                WAKTU DETEKSI NICKNAME:
              </span>
              <span
                style={{
                  fontFamily: "'Teko', sans-serif",
                  fontSize: 42,
                  color: PALETTE.lime,
                  fontWeight: 700,
                }}
              >
                0.1 DETIK SATSET
              </span>
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 12 [1620-1800]: QRIS "SCAN LANGSUNG BERES" 1.2 DETIK    */}
      {/* ============================================================== */}
      {frame >= 1620 && frame < 1800 && (() => {
        const s12Spr = getSceneSpring(1620, 13, 160);
        const badge12 = getSceneSpring(1660, 12, 180);

        // Scan laser beam animation
        const scanPos = interpolate(
          (frame - 1620) % 60,
          [0, 60],
          [20, 260],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
        );

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "120px 90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 30,
              alignItems: "center",
            }}
          >
            {/* Title */}
            <div
              style={{
                fontFamily: "'Anton', sans-serif",
                fontSize: 78,
                color: PALETTE.white,
                textAlign: "center",
                lineHeight: 1,
              }}
            >
              SCAN LANGSUNG BERES
            </div>

            {/* Stylized QRIS Mockup Box */}
            <div
              style={{
                backgroundColor: PALETTE.card,
                border: `3px solid ${PALETTE.lime}`,
                borderRadius: 16,
                padding: "30px 40px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                width: 360,
                transform: `scale(${interpolate(s12Spr, [0, 1], [0.92, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })})`,
              }}
            >
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 34,
                  color: PALETTE.white,
                  marginBottom: 16,
                  letterSpacing: "2px",
                }}
              >
                QRIS RESMI
              </div>

              {/* Pure SVG Stylized QR Matrix */}
              <div
                style={{
                  width: 280,
                  height: 280,
                  backgroundColor: PALETTE.bg,
                  borderRadius: 12,
                  padding: 20,
                  boxSizing: "border-box",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <svg width="240" height="240" viewBox="0 0 240 240">
                  {/* Top-left marker */}
                  <rect x="10" y="10" width="60" height="60" fill={PALETTE.lime} rx="4" />
                  <rect x="22" y="22" width="36" height="36" fill={PALETTE.bg} />
                  <rect x="30" y="30" width="20" height="20" fill={PALETTE.lime} />

                  {/* Top-right marker */}
                  <rect x="170" y="10" width="60" height="60" fill={PALETTE.lime} rx="4" />
                  <rect x="182" y="22" width="36" height="36" fill={PALETTE.bg} />
                  <rect x="190" y="30" width="20" height="20" fill={PALETTE.lime} />

                  {/* Bottom-left marker */}
                  <rect x="10" y="170" width="60" height="60" fill={PALETTE.lime} rx="4" />
                  <rect x="22" y="182" width="36" height="36" fill={PALETTE.bg} />
                  <rect x="30" y="190" width="20" height="20" fill={PALETTE.lime} />

                  {/* Data blocks */}
                  <rect x="90" y="20" width="20" height="40" fill={PALETTE.white} />
                  <rect x="130" y="20" width="20" height="20" fill={PALETTE.white} />
                  <rect x="90" y="80" width="40" height="20" fill={PALETTE.lime} />
                  <rect x="150" y="80" width="30" height="30" fill={PALETTE.white} />
                  <rect x="30" y="90" width="30" height="20" fill={PALETTE.white} />
                  <rect x="20" y="130" width="40" height="20" fill={PALETTE.lime} />
                  <rect x="90" y="120" width="30" height="40" fill={PALETTE.white} />
                  <rect x="140" y="130" width="40" height="30" fill={PALETTE.lime} />
                  <rect x="200" y="90" width="20" height="50" fill={PALETTE.white} />
                  <rect x="90" y="180" width="40" height="30" fill={PALETTE.white} />
                  <rect x="150" y="180" width="50" height="20" fill={PALETTE.lime} />
                  <rect x="180" y="210" width="30" height="20" fill={PALETTE.white} />
                </svg>

                {/* Laser scan line */}
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: scanPos,
                    height: 4,
                    backgroundColor: PALETTE.lime,
                    boxShadow: `0 0 12px ${PALETTE.lime}`,
                  }}
                />
              </div>
            </div>

            {/* Badge 1.2 Detik */}
            <div
              style={{
                backgroundColor: PALETTE.lime,
                color: PALETTE.bg,
                padding: "20px 48px",
                borderRadius: 8,
                transform: `scale(${interpolate(badge12, [0, 1], [0.8, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })}) rotate(-2deg)`,
                opacity: interpolate(badge12, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 15px 40px rgba(232, 243, 110, 0.3)",
              }}
            >
              <div
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 56,
                  letterSpacing: "1px",
                  textAlign: "center",
                  textTransform: "uppercase",
                }}
              >
                1.2 DETIK LANGSUNG MASUK AKUN
              </div>
            </div>

            <div
              style={{
                backgroundColor: PALETTE.waGreen,
                color: PALETTE.bg,
                fontFamily: "'Teko', sans-serif",
                fontSize: 34,
                padding: "8px 26px",
                borderRadius: 20,
                fontWeight: 700,
              }}
            >
              STATUS: SUKSES KILAT ✓
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SCENE 13 [1800-2028]: Outro Poster KYUSTORE.COM + 3 Checks     */}
      {/* ============================================================== */}
      {frame >= 1800 && frame < 2028 && (() => {
        const s13Spr = getSceneSpring(1800, 13, 150);
        const check1 = getSceneSpring(1825, 14, 160);
        const check2 = getSceneSpring(1845, 14, 160);
        const check3 = getSceneSpring(1865, 14, 160);
        const ctaSpr = getSceneSpring(1890, 12, 170);

        return (
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "100px 90px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 24,
            }}
          >
            {/* Logo */}
            <div
              style={{
                transform: `scale(${interpolate(s13Spr, [0, 1], [0.8, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })})`,
              }}
            >
              <Img
                src={staticFile("kyu-store-logo.png")}
                style={{ height: 110, objectFit: "contain" }}
              />
            </div>

            {/* Brand Title */}
            <div
              style={{
                fontFamily: "'Teko', sans-serif",
                fontSize: 180,
                lineHeight: 0.8,
                color: PALETTE.lime,
                fontWeight: 700,
                letterSpacing: "4px",
                textAlign: "center",
              }}
            >
              KYUSTORE.COM
            </div>

            <div
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 28,
                color: PALETTE.white,
                fontWeight: 700,
                textAlign: "center",
                marginTop: -10,
              }}
            >
              TEMPAT TOP UP PALING SATSET BUAT GAMER SEJATI
            </div>

            {/* 3 Checks Row */}
            <div
              style={{
                display: "flex",
                gap: 16,
                width: "100%",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <div
                style={{
                  backgroundColor: PALETTE.card,
                  border: `2px solid ${PALETTE.lime}`,
                  padding: "16px 24px",
                  borderRadius: 8,
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 36,
                  color: PALETTE.white,
                  transform: `scale(${interpolate(check1, [0, 1], [0.8, 1], {
                    extrapolateLeft: "clamp",
                    extrapolateRight: "clamp",
                  })})`,
                  opacity: interpolate(check1, [0, 0.4, 1], [0, 1, 1]),
                }}
              >
                CUMA ID ✓
              </div>

              <div
                style={{
                  backgroundColor: PALETTE.card,
                  border: `2px solid ${PALETTE.lime}`,
                  padding: "16px 24px",
                  borderRadius: 8,
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 36,
                  color: PALETTE.white,
                  transform: `scale(${interpolate(check2, [0, 1], [0.8, 1], {
                    extrapolateLeft: "clamp",
                    extrapolateRight: "clamp",
                  })})`,
                  opacity: interpolate(check2, [0, 0.4, 1], [0, 1, 1]),
                }}
              >
                AUTO-NICK ✓
              </div>

              <div
                style={{
                  backgroundColor: PALETTE.card,
                  border: `2px solid ${PALETTE.lime}`,
                  padding: "16px 24px",
                  borderRadius: 8,
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 36,
                  color: PALETTE.white,
                  transform: `scale(${interpolate(check3, [0, 1], [0.8, 1], {
                    extrapolateLeft: "clamp",
                    extrapolateRight: "clamp",
                  })})`,
                  opacity: interpolate(check3, [0, 0.4, 1], [0, 1, 1]),
                }}
              >
                QRIS ✓
              </div>
            </div>

            {/* CTA Button */}
            <div
              style={{
                marginTop: 20,
                backgroundColor: PALETTE.lime,
                color: PALETTE.bg,
                padding: "22px 48px",
                borderRadius: 8,
                transform: `scale(${interpolate(ctaSpr, [0, 1], [0.85, 1], {
                  extrapolateLeft: "clamp",
                  extrapolateRight: "clamp",
                })})`,
                opacity: interpolate(ctaSpr, [0, 0.4, 1], [0, 1, 1]),
                boxShadow: "0 15px 40px rgba(232, 243, 110, 0.35)",
              }}
            >
              <span
                style={{
                  fontFamily: "'Anton', sans-serif",
                  fontSize: 48,
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
              >
                GAS SEKARANG: KYUSTORE.COM
              </span>
            </div>

            {/* Guarantee Tag */}
            <div
              style={{
                fontFamily: "'Teko', sans-serif",
                fontSize: 36,
                color: PALETTE.muted,
                fontWeight: 600,
                letterSpacing: "1px",
              }}
            >
              NOL REPOT · NOL SPAM · 100% SATSET
            </div>
          </div>
        );
      })()}

      {/* ============================================================== */}
      {/* SUB JUDUL DINAMIS (HARD CONTRACT SPECIFICATION)               */}
      {/* top: 1450, left: 90, right: 90, tinggi: 72, bg: #18231f,       */}
      {/* border: #283a33, teks 22px bold putih, ikuti narasi VO        */}
      {/* ============================================================== */}
      <div
        style={{
          position: "absolute",
          top: 1450,
          left: 90,
          right: 90,
          height: 72,
          backgroundColor: PALETTE.card,
          border: `1px solid ${PALETTE.border}`,
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 24px",
          boxSizing: "border-box",
          zIndex: 999,
        }}
      >
        <span
          style={{
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: 22,
            fontWeight: 700,
            color: PALETTE.white,
            textAlign: "center",
            letterSpacing: "0.5px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {currentSubText}
        </span>
      </div>
    </AbsoluteFill>
  );
};
